import initializeMsw from "./initializers/initializeMsw";
import initializeSentry from "./initializers/initializeSentry";

const appInitializer = (): void => {
  initializeSentry();
  initializeMsw();
};

export default appInitializer;
